/**
 * PRD v1.1 §2.4 — rótulos de interface (usuário) vs entidades técnicas (código/DB).
 * Nunca expor nomes da coluna direita na UI.
 */
export const NAV_LABELS = {
  inicio: 'Início',
  diagnostico5Forcas: 'Diagnóstico 5 Forças',
  biblioteca5Forcas: 'Biblioteca 5 Forças',
  jornadas: 'Jornadas de Crescimento',
  microLearning: 'Micro-Learning',
  /** Produto Conselheiro (substitui o "Meu Conselho" que era só um aviso). */
  conselheiro: 'Conselheiro',
  /** A formação do conselheiro organizada pelos 10 temas (etapa 8). */
  bibliotecaDoMetodo: 'Biblioteca do método',
  /** A prova e a certificação do conselheiro (etapa 9). */
  certificacao: 'Certificação',
  hackIa: 'Hack Growth IA',
  solucoesHack: 'Soluções Hack',
  /** @deprecated use solucoesHack */
  ecossistemaHack: 'Soluções Hack',
  eventos: 'Eventos',
} as const;

export const NAV_GROUPS = {
  metodo: 'MÉTODO',
  conhecimento: 'CONHECIMENTO',
  direcao: 'DIREÇÃO',
  tecnologia: 'TECNOLOGIA',
  conexao: 'CONEXÃO',
  sobreMim: 'SOBRE MIM',
} as const;

/** Mapeamento interface → técnico (referência dev) */
export const UI_TO_TECH = {
  [NAV_LABELS.diagnostico5Forcas]: 'Ferramenta tipo DIAGNOSTICO (slug 5forcas)',
  [NAV_LABELS.biblioteca5Forcas]: 'Ferramenta (DIAGNOSTICO | QUIZ | PESQUISA)',
  [NAV_LABELS.jornadas]: 'Trilha.tipo JORNADA',
  [NAV_LABELS.microLearning]: 'Trilha.tipo MICRO',
  [NAV_LABELS.conselheiro]: 'Conselheiro / ConselheiroVinculo / EmpresaMembro',
  [NAV_LABELS.bibliotecaDoMetodo]: 'Aula.tema + Trilha.publico CONSELHEIRO (GET /api/conteudo/biblioteca)',
  [NAV_LABELS.hackIa]: 'M4 IA Assistente',
  [NAV_LABELS.solucoesHack]: 'POST /api/solutions/interest',
} as const;
